import React from 'react';
import EulaPdf from '../../assets/sara_eula.pdf';
import { PDFObject } from 'react-pdfobject';

/**
 * EULA display component that only displays the EULA for reading purposes.
 * Create-React-App hashes the filename for the pdf so it can't be pointed to with a hard-coded link so this component allows it to be viewed inside of the interface.
 */
const EulaView = () => {
  const pdfUrl = `${EulaPdf}?nocache=${new Date().getTime()}`; // Append a timestamp to prevent caching issues
  console.log('EulaView: pdfUrl: ', pdfUrl);
  return (
    <div className="eula__display">
      <PDFObject url={pdfUrl} width="100%" data-test="pdf-component" />
    </div>
  );
};

export default EulaView;
